import { render, staticRenderFns } from "./ListaDocumentosPropios.vue?vue&type=template&id=7d49b951&scoped=true&"
import script from "./ListaDocumentosPropios.vue?vue&type=script&lang=js&"
export * from "./ListaDocumentosPropios.vue?vue&type=script&lang=js&"
import style0 from "./ListaDocumentosPropios.vue?vue&type=style&index=0&id=7d49b951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49b951",
  null
  
)

export default component.exports